module.exports = __webpack_public_path__ + "img/Hatchback_Back_Side_Right.f3871fe0.svg";